import React, { useState } from "react";
import { Button } from "react-bootstrap";
import "./Common_Rate_Btn.css";


function Common_Rate_Btn({ onBtnClick }) {
  return (
    <div className="rate-buttons">
      <button className="rate-btn" onClick={onBtnClick}>
        Rate Us
      </button>
    </div>
  );
}

export default Common_Rate_Btn;
